<template>
  <div style="display: inline-block;">
    <span @click="show()" :id="'addAddressToTransport'+order.id">
      <slot></slot>
    </span>
    <el-dialog top="0vh" v-if="dialogFormVisible" class="el-dialog-sm custom-width-dialog" :close-on-click-modal="false" :modal="!mobiletype" :visible.sync="dialogFormVisible" width="90%" @close="init()">
      <div :class="{mobile_upload_order:mobiletype}">
      <h3 class="text-center">添加转运地址</h3>
      <el-form class="dialog-form">
        <ul class="error-messages" v-if="!isEmptyErrors">
          <li v-for="error in errors">{{error[0].message}}</li>
        </ul>
        <div class="form-row">
          <el-form-item class="form-row-part">
            <div class="edit-address-div" v-show="!showEditAddress" @click="showEditAddress=true">
              <SingleAddress :address="oldAddress" :noneedName="true"></SingleAddress>
              <span class="editIcon">
                <i class="el-icon-edit-outline"></i>
              </span>
            </div>
            <div v-show="showEditAddress">
              <el-form-item prop="address1">
                <YueDanIpt model="address1" :object="newAddress" placeholder="地址"></YueDanIpt>
              </el-form-item>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item prop="city">
                    <YueDanIpt model="city" :object="newAddress" placeholder="城市"></YueDanIpt>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="province">
                    <YueDanIpt model="province" :object="newAddress" placeholder="州/省"></YueDanIpt>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item prop="county">
                    <YueDanIpt model="county" :object="newAddress" placeholder="县/郡"></YueDanIpt>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="zip_code">
                    <YueDanIpt model="zip_code" :object="newAddress" placeholder="邮编"></YueDanIpt>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item prop="mobile">
                <YueDanIpt model="mobile" :object="newAddress" placeholder="电话"></YueDanIpt>
              </el-form-item>
              <el-row :gutter="20" style="margin-bottom: 10px;">
                <el-col :span="12">
                  <el-button class="block nohover" @click.stop="showEditAddress=false">取 消</el-button>
                </el-col>
                <el-col :span="12">
                  <el-button class="block" type="info" @click.stop="confirmAddress">确 定</el-button>
                </el-col>
              </el-row>
            </div>
          </el-form-item>
          <el-form-item class="form-row-part">
            <div class="id_card_div" v-if="order.id_card_id!=0 && order.id_card_info">
              <div class="bold">清关证件</div>
              <p>姓名：{{order.id_card_info.name}}</p>
              <p>身份证号：{{(role!=3 || maishouenable)?order.id_card_info.id_card:order.id_card_info.id_card.substr(0,6)+'XXXXXXXX'+order.id_card_info.id_card.substr(13)}}</p>
              <p>有效日期：{{order.id_card_info.valid_date}}</p>
              <div v-if="role!=3 || maishouenable" style="width:100%;display: flex;align-content: space-between;margin-top:7px;line-height:0;">
                <div class="id_card_img" style="margin-right:5px;">
                  <img :src="order.id_card_info.front_image_url" style="width:100%;"/>
                  <i class="iconfont el-icon-joyorderxiazai"></i>
                </div>
                <div class="id_card_img">
                  <img :src="order.id_card_info.back_image_url" style="width:100%;"/>
                  <i class="iconfont el-icon-joyorderxiazai"></i>
                </div>
              </div>
            </div>
          </el-form-item>
        </div>
        <div class="form-row" style="margin-top:-6px;">
          <el-form-item class="form-row-part" prop="transport_express_id" style="margin-bottom:0px !important;">
            <el-select style="width:100%;height:50px;"
                        v-model="transport_express_id"
                        clearable
                        filterable
                        :filter-method="remotetransportSearch"
                        class="input-width customheight_auto"
                        @change="transporthandleSelect"
                        placeholder="转运公司">
                        <el-option
                          v-for="item in remoteTrasports"
                          :key="item.id"
                          :label="item.value"
                          :value="item.id"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item class="form-row-part">
            <div>
              <el-select style="width:100%;height:50px;" class="customheight_auto" @change="search"
              v-model="zhuanyun_account_name" :placeholder="(transport_express_id && supportAccounts.length==0)?'暂无账号':'选择账号'">
                <el-option
                  v-for="item in supportAccounts"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </div>
        <div v-if="canReplace" class="form-row">
          <el-form-item style="width:100%;margin-bottom:0px !important;">
            <el-select style="width:100%;height:50px;"
                        v-model="zhuanyun_address"
                        remote
                        filterable
                        :remote-method="search"
                        :disabled="!zhuanyun_account_name"
                        class="input-width customheight_auto"
                        placeholder="输入名字,身份证,手机号"
                        :loading="loading"
                        value-key="id">
                        <el-option
                          v-for="item in oldAccounts"
                          :key="item.id"
                          :label="item.name"
                          :value="item"></el-option>
              </el-select>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button v-if="zhuanyun_address.id && zhuanyun_address.real_name==order.id_card_info.name && zhuanyun_address.identity_card==order.id_card_info.id_card" :loading="loading" style="margin-bottom:10px;" class="block" type="primary" @click="submit(true)">替换(除身份证)</el-button>
        <el-button :disabled="!transport_express_id || transport_express_id=='0' || !zhuanyun_account_name" :loading="loading" style="margin-bottom:20px;" class="block nohover" :type="zhuanyun_address.id && zhuanyun_address.real_name==order.id_card_info.name && zhuanyun_address.identity_card==order.id_card_info.id_card?'default':'primary'" @click="submit()">{{ zhuanyun_address.id?'替 换':'确 定' }}</el-button>
      </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import SingleAddress from '../../../publish_task/address/SingleAddress'
  import YueDanIpt from '../../../../components/YueDanIpt'
  import api from '../../../../services/api.js'
  let _ = require('lodash')

export default {
  name: 'AddAddressToTransport',
  props: ['order', 'isSingle','mobiletype','transportList','isSingle','supportAccountList','supportEditAccountList','role','expressList'],
  components: {
    SingleAddress,
    YueDanIpt
  },
  computed: {
    maishouenable(){
      //包含系统买手管理员role=1，商家买手管理员，普通任务买手
      return this.role==1 || this.order.single_account_id==this.account_id || (this.order.merchant_administrator_account_id_list && this.order.merchant_administrator_account_id_list.indexOf(this.account_id)>-1) 
    },
    canReplace(){
      if(this.supportEditAccountList.filter(i=>i.id==this.transport_express_id).length)
        return true
      else
        return false
    }
  },
  data () {
    return {
      newAddress:{},
      oldAddress:{},
      showEditAddress:false,
      remoteTrasports:[],
      supportAccounts:[],
      oldAccounts:[],
      keyword:'',
      transport_express_id:'',
      dialogFormVisible: false,
      isEmptyErrors: true,
      errors: null,
      loading: false,
      zhuanyun_account_name:'',
      zhuanyun_address:{},
      loading:false
    }
  },
  methods: {
    confirmAddress(){
      this.oldAddress=JSON.parse(JSON.stringify(this.newAddress))
      this.showEditAddress=false
    },
    async search(query){
      if(!this.zhuanyun_account_name)
        return
      this.loading=true
      this.oldAccounts=[]
      let res = await api.post(this, {
            path: 'order.php',
            api: 'search_transport_company_address_list',
            data: {
              keyword:query,
              transport_company_id:this.transport_express_id,
              zhuanyun_account_id:this.supportAccounts.filter(i=>i.name==this.zhuanyun_account_name)[0].id
            },
            loading: 'loading'
      })
      this.loading=false
      res = res.body
      if (res.status == 'ok') { 
        if(res.result.length){
          this.oldAccounts=res.result.map((i)=>{
            return {
              id:i.zhuanyun_address_id,
              name:i.name+','+i.mobile+','+i.region+i.city+i.address,
              real_name:i.name,
              identity_card:i.identity_card
            }
          })
          //this.zhuanyun_address=this.oldAccounts[0]
          //this.$forceUpdate()
        }
      }
    },
    async remotetransportSearch(queryString,callback){
      this.remoteTrasports=[]
      let res=this.expressList.filter((i)=>{
        return i.name.toLowerCase().indexOf(queryString.toLowerCase())>-1
      })
      _.each(res,item => {
        if(item.type == '2') {
          this.remoteTrasports.push({value:item.name,id:item.id})
          //this.form.express = item.id
        }
      })
      this.errors = null
      this.isEmptyErrors = true
      if(callback)
          callback()
    },
    transporthandleSelect (item) {
        //this.form.transport_express_id = item.id
        this.transport_express_id = item
        if(!item){
          this.remoteTrasports=[]
          this.supportAccounts=[]
        }
        else{
          if(this.supportAccountList.filter(i=>i.id==this.transport_express_id).length){
            this.supportAccounts=(this.supportAccountList.filter(i=>i.id==this.transport_express_id))[0].account_info_list
          }
          else
            this.supportAccounts=[]
        }         
    },
    async show () {
      if(this.order.transport_express_id && this.order.transport_express_id!='0'){
        this.remotetransportSearch('',()=>{
          this.transport_express_id=this.order.transport_express_id
          if(this.supportAccountList.filter(i=>i.id==this.transport_express_id).length){
            this.supportAccounts=(this.supportAccountList.filter(i=>i.id==this.transport_express_id))[0].account_info_list
          }
        })
      }
      this.dialogFormVisible = true
      this.oldAddress=JSON.parse(JSON.stringify(this.order.address)) 
      this.newAddress=JSON.parse(JSON.stringify(this.order.address))   
    },
    init () {
      this.errors = null
      this.isEmptyErrors = true
    },
    async submit(partialy) {
      this.isEmptyErrors=true;
      this.errors=[];
      if(!this.transport_express_id){
        this.isEmptyErrors = false
        this.errors = {
          business_name: [
            {message: '请输入正确的转运公司,并在下拉选项中选择该转运公司'}
          ]
        }
        return
      }
      if(!this.zhuanyun_account_name){
        this.isEmptyErrors = false
        this.errors = {
          business_name: [
            {message: '请选择转运物流委托人'}
          ]
        }
        return
      }
      let res={}
      if(this.zhuanyun_address.id){
        let data = {
                order_id: this.order.id,
                transport_company_id:this.transport_express_id,
                zhuanyun_address_id:this.zhuanyun_address.id
        }
        if(partialy){
          data.only_edit_address=1
          data.address_info=this.oldAddress
        }
        res = await api.post(this, {
              path: 'order.php',
              api: 'edit_address_to_transport_company',
              data: data,
              loading: 'loading'
        })
      }
      else{
        res = await api.post(this, {
              path: 'order.php',
              api: 'add_address_to_transport_company',
              data: {
                order_id: this.order.id,
                transport_company_id:this.transport_express_id,
                zhuanyun_account_name:this.zhuanyun_account_name
              },
              loading: 'loading'
        })
      }
      res = res.body
      if (res.status == 'ok') { 
        let data = {
            status: null,
            operationType: '添加转运地址成功',
            operation: '转运',
            needRefreshPackStatus:false
        }
        if(partialy)
          this.order.address=this.oldAddress
        this.$emit('complete', data) 
        this.dialogFormVisible = false 
      }
      else{
        this.isEmptyErrors = false
        this.errors = {
          business_name: [
            {message: res.result}
          ]
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .dialog-form {
    padding-bottom: 20px;
  }
  .tip {
    font-size: 12px;
    color: #888888;
    line-height: 16px;
  }
  .mobile_upload_order {
    padding: 0 10px !important;
  }
  .clearHistory{
    float: right;
    padding:0;
    font-size: 14px;
    color:#1066CF;
  }
  .form-row{
    display:flex;
    justify-content: space-between;
    .form-row-part{
      width:45%;
    }
  }
  .id_card_div{
    line-height:22px;
  }
  .search-button{
    cursor: pointer;
    &.disabled{
      cursor: not-allowed;
      opacity: 0.5;
    }
  }
  .edit-address-div{
    position: relative;
    cursor: pointer;
    .editIcon{
      position:absolute;
      display: none;
      right:0;
      top:-5px;
    }
    &:hover{
      .editIcon{
        display: block;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/orders/list/single/AddAddressToTransport.vue